import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  enableChasisWrap,
  enableManufacturerWrap,
} from "../../redux/TradeInSlice";
import { getEdgeClass } from "../../utils";
import Tooltip from "../common-components/Tooltip";

const ChasisNumberField = ({
  setFieldValue,
  values,
  errors,
  toggleChasisNumberHandler,
  isDisableChasisField,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { edge } = useSelector((state) => state.uiConfig);
  const handleInputChange = (e) => {
    let value = e.target.value;
    setFieldValue("chasisNumber", e.target.value);
    if (value) {
      dispatch(enableChasisWrap());
      toggleChasisNumberHandler(true);
    } else {
      dispatch(enableManufacturerWrap());
      toggleChasisNumberHandler(false);
    }
  };

  return (
    <>
      <h5 className="font-medium text-xl">
        {t("/vehicleDetails.Chassis number")}
      </h5>
      <div className="flex max-md:flex-col">
        <div className="w-[35%] max-md:w-full">
          <img
            src="https://cdn.dein.auto/pxc-os/content/assets/images/online-sales/vin.png"
            className="w-full"
            alt="Car-Number-Plate-Img"
          />
        </div>
        <div className="w-[65%] max-md:w-full">
          <div className="pl-10 max-md:pl-0">
            <label className="flex items-center mb-4">
              {t("/vehicleDetails.FIN")}&nbsp;
              <span className="text-red-700 pr-2">*</span>
              <Tooltip
                text={
                  <div>
                    {t(
                      "/vehicleDetails.You can find the vehicle identification number or chassis number in your vehicle registration document under item E.",
                    )}{" "}
                    <br />{" "}
                    {t(
                      "/vehicleDetails.On many vehicles, this number can be found under the windshield or on a sticker in the driver's door.",
                    )}
                  </div>
                }
                spanClassName={
                  "max-sm:translate-x-[-5rem] max-sm:max-w-[16rem] max-w-[18rem]"
                }
              >
                <abbr title="require">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 11.8333C8.18889 11.8333 8.34733 11.7693 8.47533 11.6413C8.60333 11.5133 8.66711 11.3551 8.66667 11.1667C8.66622 10.9782 8.60222 10.82 8.47467 10.692C8.34711 10.564 8.18889 10.5 8 10.5C7.81111 10.5 7.65289 10.564 7.52533 10.692C7.39778 10.82 7.33378 10.9782 7.33333 11.1667C7.33289 11.3551 7.39689 11.5136 7.52533 11.642C7.65378 11.7704 7.812 11.8342 8 11.8333ZM7.33333 9.16667H8.66667V5.16667H7.33333V9.16667ZM5.5 14.5L2 11V6L5.5 2.5H10.5L14 6V11L10.5 14.5H5.5ZM6.06667 13.1667H9.93333L12.6667 10.4333V6.56667L9.93333 3.83333H6.06667L3.33333 6.56667V10.4333L6.06667 13.1667Z"
                      fill="#0F74C7"
                    ></path>
                  </svg>
                </abbr>
              </Tooltip>
            </label>
            <input
              type="text"
              id="chasisNumber"
              className={`${getEdgeClass(edge)} h-[48px] w-full placeholder:text-[var(--gray-color)] border border-[var(--gray-color)] text-sm py-3 px-4 pr-11 bg-[var(--white-shade)] focus:ring-0 focus:border-[var(--gray-color)]
              ${
                errors?.chasisNumber
                  ? "border-[var(--red-color)]"
                  : "border-[var(--gray-color)]"
              }`}
              placeholder={t("/vehicleDetails.Enter chassis number")}
              value={values.chasisNumber}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ChasisNumberField;
